import React, {Component} from 'react';

class BoxTitle extends Component {
    render() {
        return (
            <div className={"exh4"}>
                {this.props.title}
            </div>
        );
    }
}

export default BoxTitle;